import axios from "axios";

import SecurityService from "../services/SecurityService";

let axiosOptions = {
    baseURL: process.env.REACT_APP_API_SERVER_URL,
    // timeout: 5000,
    headers: {
        'Content-Type': 'application/json',
        "Access-Control-Allow-Origin": "*",
        Authorization: {
            toString () {
                const accessToken = SecurityService.getAccessToken();
                if (null !== accessToken) {
                    return "Bearer " + accessToken;
                }
                return "";
            }
        }
    }
};

const HTTP = axios.create(axiosOptions);

HTTP.interceptors.response.use(
    response => response,
    error => {
        console.log(error)
        console.log(error.response)
        // const originalRequest = error.config;
        if ((SecurityService.getAccessToken() && error.response === undefined)
            || (error.response !== undefined && error.response.status === 401)) {

            // if(!SecurityService.getRefreshStatus()) {
            //     SecurityService.setRefreshStatus();
            //     SecurityService.refreshToken().then(() => {
            //         window.location.reload();
            //     });
            //     return Promise.reject(error);
            // } else {
                SecurityService.logout();
                window.location.href = "/#/login";
                window.location.reload();
            //}
        }

        // else if (error.response !== undefined && error.response.status === 400) {
        //     const {data} = error.response;
        //
        //     if (data.errors !== undefined && data.errors.length > 0) {
        //         store.dispatch(setFormMessagesAction(errorsResponseMessages(data.errors)));
        //     } else {
        //         var message = error.message;
        //         var field = "defaultMessage";
        //         store.dispatch(setFormMessagesAction(errorResponseMessage(message, field)));
        //     }
        // }

        // else if (error.response !== undefined && error.response.status === 500) {
        //     store.dispatch(setFormMessagesAction(errorResponseMessage(error.response.data.message, "defaultMessage")));
        // }

        return Promise.reject(error);
    }
);

// const HTTP = axios.create({
//     baseURL: "http://localhost:8087/api",//window.API_URL,
//     headers: {
//         'Content-Type': 'application/json; charset=utf-8'
//     }
// });

// HTTP.interceptors.response.use(
//     response => response,
//     errorHandler
// );

export {HTTP};